export default __webpack_public_path__ + "static/media/ld.73795ffc.png";